var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holidayguru"},[_c('AmadeusPackageTourSearch',{attrs:{"show-cooperation":_vm.showCooperation,"theme":_vm.theme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }